import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState, AppDispatch } from "../../redux/store";
import { userLogout } from "../../redux/reducers/user";

const ResetPasswordSuccess: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();
  const { allArtifacts } = useSelector((state: RootState) => state.app);

  const transactionPassword = (location.state as any)?.transactionPassword;
  const baseUrl = allArtifacts?.base_url || "https://allpanel.buzz";
  const displayDomain = baseUrl.replace(/^https?:\/\//i, "");

  if (!transactionPassword) {
    navigate("/login", { replace: true });
    return null;
  }

  const handleBack = () => {
    dispatch(userLogout());
  };

  return (
    <div className="cp-success-box">
      <div className="text-center container">
        <h1>
          <span className="text-success">Success! Your password has been updated successfully.</span>
        </h1>
        <h1>
          Your transaction password is <span className="text-info token-box">{transactionPassword}</span>.
        </h1>
        <h2>
          Please remember this transaction password, from now on all transcation of the website can be done only with
          this password and keep one thing in mind, do not share this password with anyone.
        </h2>
        <h2 className="mt-3 text-dark">Thank you, Team {displayDomain}</h2>
        <div className="font-hindi">
          <h1 className="mt-5">
            <span className="text-success">Success! आपका पासवर्ड बदला जा चुका है।</span>
          </h1>
          <h1>
            आपका लेनदेन पासवर्ड <span className="text-info token-box">{transactionPassword}</span> है।
          </h1>
          <h2>
            कृपया इस लेन-देन के पासवर्ड को याद रखें, अब से वेबसाइट के सभी हस्तांतरण केवल इस पासवर्ड से किए जा सकते
            हैं और एक बात का ध्यान रखें, इस पासवर्ड को किसी के साथ साझा न करें।
          </h2>
          <h2 className="mt-3 text-dark">धन्यवाद, टीम {displayDomain}</h2>
        </div>
        <button
          type="button"
          className="btn btn-dark btn-lg mt-5"
          style={{ minWidth: "200px" }}
          onClick={handleBack}
        >
          <i className="fas fa-arrow-left mr-3" />
          Back
        </button>
      </div>
    </div>
  );
};

export default ResetPasswordSuccess;
